<template>
  <div class="h-full" style="height: 400px">
    <AgGridVue
      style="width: 100%; height: 100%"
      :theme="standardListTheme"
      :column-defs="columnDefs"
      :default-col-def="defaultColDef"
      :row-data="meetings"
      :loading="loading"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue3';
import { standardListTheme } from '@/utils/common';
import CC_Router_Link_To_Entity from '../widgetcomponents/AG_Grid_Custom_Cells/CC_Router_Link_To_Entity.vue';
import { format } from 'date-fns';

export default {
  name: 'ScheduledMeeting_Table',
  components: {
    AgGridVue,
  },
  props: {
    userId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      meetings: [],
      loading: false,
      gridApi: null,
      defaultColDef: {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columnDefs: [
        {
          headerName: 'Date & Time',
          field: 'start_datetime',
          width: 180,
          valueFormatter: (params) => {
            if (!params.value) return '';
            const date = new Date(params.value);
            return format(date, 'MMM d, yyyy h:mm a');
          },
        },
        {
          headerName: 'Subject',
          field: 'subject',
          minWidth: 250,
        },
        {
          headerName: 'Entity',
          field: 'entity_name',
          minWidth: 200,
          cellRenderer: CC_Router_Link_To_Entity,
          cellRendererParams: {
            dataType: 'entity',
            idField: 'entity_id',
            nameField: 'entity_name',
          },
        },
        {
          headerName: 'User',
          field: 'user_name',
          width: 180,
        },
      ],
    };
  },
  computed: {
    standardListTheme() {
      return standardListTheme;
    },
  },
  async mounted() {
    await this.fetchMeetings();
  },
  methods: {
    async fetchMeetings() {
      this.loading = true;
      try {
        const params = {};
        if (this.userId) {
          params.user_id = this.userId;
        }

        const response = await axios.get('/api/scheduled-meetings/', { params });
        this.meetings = response.data;
      } catch (error) {
        console.error('Error fetching scheduled meetings:', error);
        this.meetings = [];
      } finally {
        this.loading = false;
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', this.onWindowResize);
    },

    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
  },
  watch: {
    userId() {
      this.fetchMeetings();
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }
};
</script>
